import type {Components, Theme} from '@mui/material/styles';

declare module '@mui/material/Switch' {
  export interface SwitchPropsSizeOverrides {
    tiny: true;
    large: true;
  }
}

const sizes = {
  large: {
    width: 56,
    height: 32,
    thumb: 26,
    transform: 24,
  },
  medium: {
    width: 32,
    height: 20,
    thumb: 18,
    transform: 11.5,
  },
  small: {
    width: 24,
    height: 16,
    thumb: 14,
    transform: 7.5,
  },
  tiny: {
    width: 19,
    height: 13,
    thumb: 11,
    transform: 5.5,
  },
};

export const MuiSwitch = (theme: Theme): Components['MuiSwitch'] => ({
  styleOverrides: {
    root: ({ownerState}) => {
      const style = sizes[ownerState.size ?? 'medium'];
      return {
        'width': style.width,
        'height': style.height,
        'padding': 0,
        'display': 'flex',
        '& .MuiSwitch-switchBase': {
          'padding': ownerState.size === 'large' ? '3px' : '1px 1.25px',
          '&.Mui-checked': {
            'transform': `translateX(${style.transform}px)`,
            'color': theme.palette.onColorText,
            '& + .MuiSwitch-track': {
              opacity: 1,
              backgroundColor: theme.palette.primaryBrandBg,
            },
          },
        },
        '& .MuiSwitch-thumb': {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: style.thumb,
          height: style.thumb,
          borderRadius: '50%',
          boxShadow: 'none',
          background: theme.palette.mode == 'light' ? theme.palette.bg : theme.palette.negativeBg,
          transition: theme.transitions.create(['width'], {
            duration: 200,
          }),
        },
        '& .MuiSwitch-track': {
          borderRadius: Number(theme.shape.borderRadius) * 4,
          opacity: 1,
          backgroundColor: theme.palette.bg4,
          boxSizing: 'border-box',
        },
        '& .MuiSwitch-switchBase.Mui-disabled+.MuiSwitch-track': {
          opacity: 1,
          background: theme.palette.bg3,
        },
        '& .MuiSwitch-switchBase.Mui-disabled .MuiSwitch-thumb': {
          background: theme.palette.bg4,
        },
      };
    },
  },
});
